import withPageHandler from '~pricing/hocs/withPageHandler';
import PricingSummary from './Summary';
import PricingDetails from './Details';
import EnterprisePage from './Enterprise';
import EducationalPage from './Educational';

import GROW2792Summary from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/Summary';
import GROW2792Details from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/Details';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { Page } from '../types';

/**
 * Please note <domain>/pricing/details is a valid route that renders the team details page
 * We should always take into account this route in all our experiments and use cases.
 */
export default function GetPricingPage(): Page[] {
  const { priceExperiment } = usePricingExperiments();
  const isPnPRefresh =
    priceExperiment?.hasAssignment && priceExperiment?.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment;

  const PricingPage = isPnPRefresh ? GROW2792Summary : PricingSummary;
  const DetailsPage = isPnPRefresh ? GROW2792Details : PricingDetails;

  return [
    {
      component: withPageHandler(PricingPage),
      paths: [
        '/pricing',
        '/pricing/',
        '/pricing/upgrade/',
        '/pricing/upgrade/quickview/',
        '/pricing/:canonicalPath(individual|teams)',
      ],
    },
    {
      component: withPageHandler(EnterprisePage),
      paths: ['/pricing/:canonicalPath(enterprise)/:subPath(details)?'],
    },
    {
      component: withPageHandler(DetailsPage),
      paths: ['/pricing/:canonicalPath(details|individual|teams)?/:subPath(details)'],
    },
    {
      component: withPageHandler(EducationalPage),
      paths: ['/pricing/:canonicalPath(educational)'],
    },
  ];
}
